import React from "react";
import { Col, Row, Button } from "react-bootstrap";
import Select, { components } from "react-select";
import {connect} from "react-redux";
class Filter extends React.Component {
    state = {
        zindex:-1,
        pindex:-1,
        cindex:-1
    }
    render() {
        const { Option } = components
        const zones = []
        const plots = []
        const cropsland = []
        if(this.state.zindex !== -1){
            this.props.zones.forEach((e,zindex)=>{
                zones.push({value:e.name,label:e.name,index:zindex})
            })
            this.props.zones[this.state.zindex].plots.forEach((p,pindex)=>{
                plots.push({value:p.name,label:p.name,parent:this.state.zindex,index:pindex})
            })
            if(this.state.pindex !== -1 && this.state.zindex !== -1 && this.state.pindex!==null && this.state.zindex!==null ){
                const cl = this.props.zones[this.state.zindex]
                if(cl){
                    const pt = cl.plots[this.state.pindex];
                    if(pt){
                        pt.cropsland.forEach((c,cindex)=>{
                
                            cropsland.push({ value: c.name,acre:c.acre,color:c.pinColor,label:c.name, pindex:this.state.pindex,index:cindex })
                        })
                    }
                }
              
            }
        }else{
            this.props.zones.forEach((e,zindex)=>{
                zones.push({value:e.name,label:e.name,index:zindex})
            })
        }
       
        const tasks = []
        if(this.state.zindex !== -1 && this.state.pindex !== -1 && this.state.cindex !== -1){
            const cl = this.props.zones[this.state.zindex]
            if(cl){
                const pt = cl.plots[this.state.pindex]
                if(pt){
                    const cp = pt.cropsland[this.state.cindex]
                    if(cp){
                        const name = cp.name
                        this.props.tasks.forEach(e=>{
                        if(e.status === name){
                        tasks.push(e)
                        }
                        })
                    }
                }
            }
         
        }

        const CCustomSelectOption = props => (
            <Option  {...props}>
             <div style={{
                fontSize:"7px",
                display:"flex",
                alignItems:"center",
                  
            }}>
            <span> <i style={{
                 color:props.data.color
            }}  class="fas fa-circle"></i></span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"700"
              }}>&nbsp; {props.data.label} </span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"400"
              }}>&nbsp; | {props.data.acre} acre</span>
            </div>
            </Option>
          )
          const CCustomSelectValue = props => (
           
            <div style={{
                fontSize:"7px",
                display:"flex",
                alignItems:"center",
                  
            }}>
       <span> <i style={{
                 color:props.data.color
            }}  class="fas fa-circle"></i></span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"700"
              }}>&nbsp; {props.data.label} </span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"400"
              }}>&nbsp; | {props.data.acre} acre</span>
            </div>
          )    
        const curvedStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                fontSize:"14px",
                fontWeight:"500"
            })

        }
    

        const dot = {
            background: "green",
            width: "7px",
            height: "7px",
            borderRadius: "100px",
        }
        return (
            <div className="p-3">
                <div>
                    <Row>
                        <Col md={7}><p style={{
                            fontSize: "23px",
                            fontWeight: "500"
                        }}>Tasks</p></Col>
                        <Col md={5} style={{
                            padding: "0 20px 0 0"
                        }}><Button onClick={this.props.toggleFilter} style={{ 
                            backgroundColor: "white", 
                            borderRadius: "25px", 
                            color: "#3E7AFF",
                            borderColor: "#3E7AFF",
                            width: "95px",
                            height: "40px",
                            fontSize: "14px",
                            fontWeight: "500px"
                            }}><i style={{ margin: "0.2rem" }} class="fas fa-chevron-up"></i><small style={{
                                paddingLeft: "7px",
                                fontSize: "100%"
                            }}>Filter</small></Button></Col>
                    </Row>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className="text-muted mb-2" style={{
                        fontSize: "12px"
                    }}>Zone</p>
                    <Select  components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStyle}  isSearchable={false} options={zones} onChange={(info) => { 
        
                        this.setState({
                            zindex:info.index
                        })

                    }}></Select>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className="text-muted mb-2" style={{
                        fontSize: "12px"
                    }}>Plot</p>
                    <Select  components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStyle} isSearchable={false} options={plots} onChange={(info) => {
                        this.setState({
                            pindex:info.index
                        })
                     }}></Select>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className="text-muted mb-2" style={{
                        fontSize: "12px"
                    }}>Cropland</p>
                    <Select key={4} components={{ Option: CCustomSelectOption, SingleValue: CCustomSelectValue,IndicatorSeparator: () => null }} styles={curvedStyle} isSearchable={false} options={cropsland} onChange={(info) => { 
                        this.setState({
                            cindex:info.index
                        })
                    }}></Select>
                </div>
                <div style={{
                    overflowX:"hidden",
                    overflowY:"scroll",
                    height:"210px",
                    scrollbarWidth:"thin"
                }} className="mt-4 d-flex flex-column ">
                      {tasks.map(e=>{
                          return (
                            <div className="d-flex row justify-content-around mb-2">
                            <div className="align-items-start">
                                <Row className="align-items-center">
                                    <div style={dot} className="ml-3 mr-1" /> <p className="text-muted" style={{ fontSize: "12px", fontWeight:"400",margin: 0 }}>{e.completiontime}</p>
                                </Row>
                                <strong className="strong" style={{ fontSize: "14px",fontWeight:"500", padding: 0, }}>{e.tracktername}</strong>
                                <p className="text-muted" style={{ fontSize: "12px",fontWeight:"400", margin: 0 }}>{e.status}</p>
                            </div>
                            <div style={{
                                className: "d-flex justify-content-center align-items-center",
                                width: "65px",
                                height: "65px",
                                border: "2px #e6f9f0 solid",
                                borderRadius: "2000px",
                                background: "white",
                                textAlign: "center"
                            }}>
                            <div className="text-center" style={{ marginTop: "calc(50% - 10px)" }}>0%</div>
                            </div>             
                        </div>
                          )
                      })}
                </div>
                <button
                    onClick={() => {
                        this.props.toggleFilterFalse()
                    }
                    }
                    style={{
                        marginTop: "0.5rem"
                    }} className="blue_button">
                    Create New Task
             </button>
            </div>
        )
    }
}

const mapStateToProps = (state)=>{
    return {
        zones:state.zones,
        tasks:state.tasks,
    }
}

export default connect(mapStateToProps,null)(Filter);